import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetFolderRestrictedMutationVariables = Types.Exact<{
  input: Types.SetFolderRestrictedInput;
}>;


export type SetFolderRestrictedMutation = { __typename?: 'Mutation', setFolderRestricted?: { __typename?: 'SetFolderRestrictedPayload', folderAsset?: { __typename?: 'FolderAsset', id: string, restricted?: boolean | null } | null } | null };


export const SetFolderRestricted = /*#__PURE__*/ gql`
    mutation SetFolderRestricted($input: SetFolderRestrictedInput!) {
  setFolderRestricted(input: $input) {
    folderAsset {
      id
      restricted
    }
  }
}
    ` as unknown as DocumentNode<SetFolderRestrictedMutation, SetFolderRestrictedMutationVariables>;

          

          export const useSetFolderRestrictedMutation = (options?:MutationHookOptions<SetFolderRestrictedMutation, SetFolderRestrictedMutationVariables>) => useMutation(SetFolderRestricted, options);
          

          export type SetFolderRestrictedMutationOptions = MutationHookOptions<SetFolderRestrictedMutation, SetFolderRestrictedMutationVariables>;

          

          export type SetFolderRestrictedMutationResult = ReturnType<typeof useSetFolderRestrictedMutation>[1];

          
